'use client';

import { Url } from '../types';
import Breadcrumb from './Breadcrumb';

type Props = {
  items?: Url[];
  type?: 'gradient' | 'background_image' | 'live' | 'team' | 'news';
};

export default function HistoryBreadcrumb({ type, items }: Props) {
  return <Breadcrumb items={items} type={type} />;
}
